export enum ModelActionType {
  SAY = 'SAY',
  HIBERNATE = 'HIBERNATE',
  MODIFY_CART = 'MODIFY_CART',
  NONE = 'NONE',
}
